import { ComponentInterface, Entity } from '@goodboydigital/odie';

import { PhysicsComponent } from '../physics';

export enum ReplayStateMode
    {
    IDLE,
    RECORD,
    PLAYBACK,
}

export class ReplayStateComponent implements ComponentInterface
{
    public physics?: PhysicsComponent;
    public mode: ReplayStateMode;
    public playing = false;

    /** Sequence of values to be converted into x/y/angle */
    public buffer: number[];

    /** Buffer position */
    public position = 0;

    /** Number of values per record step - stateh */
    public itemSize = 1;

    /** Length of each step */
    public stepSize = 8;

    public getState?: () => number;
    public setState?: (prev: number, current: number, next: number) => void;

    constructor()
    {
        this.mode = ReplayStateMode.IDLE;
        this.buffer = [];
    }

    public reset(): void
    {
        this.playing = false;
        this.mode = ReplayStateMode.IDLE;
        this.position = 0;
    }

    public addedToEntity(entity: Entity): void
    {
        const physics = entity.getComponent(PhysicsComponent);

        if (physics)
        {
            this.physics = physics;
            this.physics.physicsFixedUpdateRunner.add(this as any);
        }
    }

    public physicsFixedUpdate(): void
    {
        if (!this.physics) return;
        if (this.mode === ReplayStateMode.RECORD)
        {
            this.recordStep();
            this.position += 1;
        }
        else if (this.mode === ReplayStateMode.PLAYBACK)
        {
            this.playbackStep();
            this.position += 1;

            const end = (this.buffer.length / this.itemSize * this.stepSize) - 1;

            if (this.position >= end) this.position = end;
        }
    }

    public startRecording(): void
    {
        if (!this.physics || this.mode === ReplayStateMode.RECORD) return;
        this.position = 0;
        this.buffer = [];
        this.mode = ReplayStateMode.RECORD;
    }

    public stopRecording(): void
    {
        if (!this.physics || this.mode !== ReplayStateMode.RECORD) return;
        this.mode = ReplayStateMode.IDLE;
    }

    public startPlayback(): void
    {
        if (!this.physics || this.mode === ReplayStateMode.PLAYBACK) return;
        this.position = 0;
        this.mode = ReplayStateMode.PLAYBACK;
    }

    public stopPlayback(): void
    {
        if (!this.physics || this.mode !== ReplayStateMode.PLAYBACK) return;
        this.mode = ReplayStateMode.IDLE;
    }

    public setBuffer(buffer: number[], stepSize: number): void
    {
        this.stepSize = stepSize;
        this.position = 0;
        this.buffer = buffer;
        this.playbackStep();
    }

    private recordStep(): void
    {
        if (!this.physics) return;

        const state = this.getState ? this.getState() : -1;

        this.buffer.push(state);
    }

    private playbackStep(): void
    {
        if (!this.physics) return;

        // Buffer position considering the step size
        const pos = Math.floor(this.position / this.stepSize);

        // Buffer base index
        const i = Math.min(pos, this.buffer.length - 2);

        const z0 = this.buffer[i - 1] || -1; // prev state
        const a0 = this.buffer[i]; // current state
        const b0 = this.buffer[i + 1]; // next state
        // const c0 = this.buffer[i + 1] || -1;

        // const t = (1 / this.stepSize) * (this.position % this.stepSize);
        // const current = t <= 0.5 ? a0 : b0;
        // const next = t <= 0.5 ? b0 : c0;

        // this.setState && this.setState(current, next);

        this.setState && this.setState(z0, a0, b0);
    }
}
